const paths = {
  payments: {
    index: '/',
  },
  account: {
    index: '/customers/payments',
    verifyEmail: '/verify-email',

    login: '/login',
    logout: '/logout',
    signup: '/signup',

    account: '/account',

    customers: {
      index: '/customers',
      payments: '/customers/payments',
      payouts: {
        index: '/customers/payouts',
        upload: '/customers/payouts/upload',
      },
      reports: '/customers/reports',
    },

    withdrawals: {
      index: '/withdrawals',
      withdraw: '/withdrawals/withdraw',
    },

    topUps: {
      index: '/top_ups',
      topUp: '/top_ups/top_up',
    },
  },
  trader: {
    index: '/deposits/active',
    payouts: {
      index: '/payouts/available',
      assigned: '/payouts/assigned',
      available: '/payouts/available',
      archived: '/payouts/archive',
      disputed: '/payouts/disputed',
    },
    deposits: {
      index: '/deposits/working_credentials',
      working_credentials: '/deposits/working_credentials',
      credentials: '/deposits/credentials',
      automation: '/deposits/automation',
      created: '/deposits/active',
      archived: '/deposits/archive',
      disputed: '/deposits/disputed',
    },
    balance: '/balance',
    account: {
      index: '/account',
      team: '/account/team',
    },
    cryptoAccount: {
      index: '/crypto_account/top_up',
      withdraw: '/crypto_account/withdraw',
      withdrawals: '/crypto_account/withdrawals',
      topUp: '/crypto_account/top_up',
      topUps: '/crypto_account/top_ups',
    },
    statistics: {
      index: '/statistics',
      deposits: {
        index: '/statistics/deposits',
        unissued: '/statistics/deposits/unissued',
      },
      reports: '/statistics/reports',
    },
  },
} as const;

export default paths;
